import React, {useEffect} from 'react';
import styles from './Modal.module.css';
import Modal from './Modal';
import ModalNotif from "./ModalNotif";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';

function ModalError({ children, onClose }) {
    return (
        <ModalNotif onClose={onClose} className={`${styles.modalError} ${styles.modalContainer}`}>
            <FontAwesomeIcon icon={faCircleExclamation}/>
            {children}
        </ModalNotif>
    );
}

export default ModalError;
